export default {
  svgData: [
    {
      id: "slide4kiosk1",
      url: "https://0013915-noise.scoutfeedback.com",
      name: "Kiosk",
      label: "slide4kiosk1"
    },
    {
      id: "slide4easel1",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/airnoise/eic-noise-barrier-timeline.jpg"
      ],
      name: "Easel",
      label: "slide4easel1"
    },
    {
      id: "slide4display1",
      name: "Display",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/general/air-quality-1-1.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/air-quality-1-2.jpg"
      ],
      label: "slide4display1"
    },
    {
      id: "slide4display2",
      name: "Display",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/general/noise-fact-sheet-1.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/noise-fact-sheet-2.jpg"
      ],
      label: "slide4display2"
    },
    {
      id: "slide4display3",
      name: "Display",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/general/noise-brochure-1.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/general/noise-brochure-2.jpg"
      ],
      label: "slide4display3"
    },
    {
      id: "slide4avatar1"
    },
    {
      id: "slide4bubble1"
    }
  ],
  slideTitle: "Air/Noise Impacts",
  aboutText: `
    <p class="text-justify help">
    In compliance with the National Environmental Policy Act (NEPA) and part of the Draft Environmental Assessment (EA), noise and air impacts are just two of the environmental and related social and economic effects that are studied for a transportation project. Georgia DOT measures potential noise and air impacts to residences, businesses, and other properties adjacent to the proposed project. Findings presented in the draft EA are preliminary; the locations, heights, and need for noise barriers may change as part of the noise analysis completed during final design.
    </p>
    <p class="text-justify help">
    A Noise Impact Assessment or Noise Screening Assessment will be completed for every federal-aid highway project in the state of Georgia authorized under Title 23 United States Code. This includes federal-aid projects that are administered by Georgia DOT, local public agencies, and roadways operated by others on behalf of the state of Georgia. The Georgia DOT Noise Abatement Policy provides engineers criteria for evaluating noise impacts.
    </p>
    <p class="text-justify help">
    An Air Assessment that considers a project’s impact on air quality will be completed for every federal-aid and state-funded transportation project. For federal-aid projects, the 1990 Clean Air Act (CAA), issued by the Environmental Protection Agency (EPA), sets forth guidelines to be followed by agencies responsible for attainment of the National Ambient Air Quality Standards (NAAQS). The CAA requires that federal transportation projects are consistent with state air quality goals, found in the State Implementation Plan (SIP), to determine if a project would adversely or significantly impact air quality.
    </p>
    <p class="text-justify help">
    Once your tour of the Noise and Air Impact station is complete, we invite you to visit the next station by clicking on the right arrow or selecting your station of choice from the sidebar on the right.
    </p>
  `,
  helpText: `
  <p class="text-justify help">
  Part of the Draft Environmental Assessment (EA) includes the study of potential noise and air impacts to residences, businesses, and other properties adjacent to the proposed project.
  </p>
  <p class="text-justify help">
  In this space, we recommend the following actions to help you better explore detailed noise and air impact information made available to you by Georgia DOT:  
  </p>
  <ul class="text-justify help">
  <li>
  For general noise impact information, select <b><u>Noise Brochure</b></u> and <b><u>Noise FAQ</b></u> on the table. 
  </li>
  <br>
  <li>
  For project-specific noise impact information, click the <b><u>Noise Study Results</u></b> kiosk which links to an interactive tool that identifies potential noise impacts, proposed noise barrier locations, and the predicted noise reductions from those barriers. The map is interactive and includes a search box where you can type in an address to see expected noise results within the study area at that location. You can also click the easel to the right to view the <b><u>Noise Barrier Timeline</u></b> specific to the I-285/I-20 East Interchange Project. 
  </li>
  <br>
  <li>
  For general information regarding air impacts, click the <b><u>Air Quality FAQ</b></u>. 
  </li>
</ul>
<br>
  <p class="text-justify help">
  Regarding noise barrier locations, it is important to note that because the final design of the project isn’t completed, the locations, heights, and need for noise barriers could change.
  </p>
  <p class="text-justify help">
  <b>Click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i> to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i> to see this message again after you close it out. To return to the project website, select the <i class="mdi mdi-exit-to-app" style="font-size:2em;"></i> icon. </b>
  </p>
  `
};
